/**
 * @desc 新品下单导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  body: defs.basics.PlmSkuNewOrderRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/order/exportExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
